<script>
    import BlogSummary from '../components/BlogSummary.svelte';
    export let short = false;
    export let blogUrl = "kunto_nousuun_kelkkaharjoittelulla";
    let title = "Kunto nousuun kelkkailemalla";
    let author = "Mata";
    let blogDate = "6.1.2015";
    let titlePic = "2015/kelkat.jpg";
    let firstPara = "Kelkkaa on käytetty kautta historian osana fysiikkaharjoittelua nopeusvoima- ja kunto-ominaisuuksien kehittämiseen. Myös tavallinen kuntoilija hyötyy kelkkaharjoittelusta. ";
</script>
<!--  Blogi koostuu kahdesta osasta. Eka osa "short" on siis muille siuville tuleva lyhennelmä, jossa on artikkelikuva ja lyhyt teksti -->

{#if short}
<BlogSummary blogPath={blogUrl} title={title} titlePic={titlePic} blogDate={blogDate} firstPara={firstPara}></BlogSummary>

{:else}
    <div class="blog page">
        <article class="container">
            <h1>{title}</h1>
            <div class="blogDate">{author} | {blogDate}</div>
            <div class="blogMainImage" style="background-image: url('/svelte-site/img/blog/{titlePic}')"></div>
            
            
            <p>Urheilijat ovat kautta historian käyttäneet kelkkaa osana fysiikkaharjoittelua nopeusvoima- ja 
                kunto-ominaisuuksien kehittämiseen. On monia syitä miksi myös tavallinen kuntoilija hyötyy 
                kelkkaharjoittelusta. Kelkkailu haastaa sekä lihaskunnon että hapenottokyvyn tehokkaasti. 
                Kuormaa on helppo säätää niin että kaikenkuntoiset kuntoilijat saavat lyhyestäkin treenistä 
                paljon irti.</p>
                
            <h2>Korkean intensiteetin tehotreenejä turvallisesti</h2>
            
            <p>Kelkkailu on turvallinen tapa myös aloittelijalle tehdä korkean intensiteetin tehotreenejä.
            Kelkalla on vaikea tehdä liikkeitä väärin, joten loukkaantumisriski on minimaalinen. 
            On vaikea keksiä toista harjoitetta jossa kuormituksen on mahdollista saada yhtä suureksi
            samalla loukkaantumisriskin pysyessä lähes olemattomana. Ihminen osaa luonnostaan tarttua 
            kelkkaan ja ryhtyä työntämään sitä, ja jos esimerkiksi kyykyn kanssa on ongelmia, kelkassa 
            saadaan tarvittaessa kuritettua reisiä ilman hankalia nivelkulmia.</p>
             
            <p>Kelkan työntö on helpoin ja yleisimmin käytetty harjoite, kun puhutaan kelkkailusta harjoittelussa. 
            Koko kroppa työskentelee, sillä kun jalat työntävät kelkkaa niin myös muun vartalon täytyy 
            olla todella tiukkana, jotta voima siirtyy keskivartalon ja käsien kautta kelkan liike-energiaksi.
            Myös hapenkulutus on suurta ja syke pysyy korkealla.</p>
             
            <h2>Nopeusvoimaa ja nopeaa palautumista</h2>
             
            <p>Treenin jälkeistä kipua lihaksissa aiheuttaa erityisesti liikkeen eksentrinen vaihe eli laskuvaihe, 
            jossa aktiivisesti vastustetaan lihaksen pidentymistä. Esimerkiksi kyykyssä tai penkkipunnerruksessa 
            alaslaskuvaihe. Tämä jarruttaminen aiheuttaa erityisen paljon lihasten mikrovaurioita, mikä ilmenee 
            treenin jälkeisenä lihaskipuna.</p>

            <p>Kelkkaharjoittelussa tätä eksentristä vaihetta ei tapahdu käytännössä lainkaan, missä piilee 
                juurikin kelkkaharjoittelun erikoisuus.</p>
             
            <p>Jos tavoite on kasvattaa lihasmassaa, on hyödyksi myös eksentrisen vaiheen maksimaalinen hyödyntäminen. 
            Tällöin myös treenitiheys on melko harva - esimerkiksi koko kroppa kerran viikossa - jolloin lihakset
            ehtivät palautua ennen seuraavaa treeniä.</p>
             
            <p>Mikäli halutaan palautua nopeasti ja treenata useammin tai keskittyä esimerkiksi nopeusominaisuuksien 
            kehittämiseen, on hyvä hyödyntää ohjelmoinnissa myös liikkeitä jotka kehittävät voimaa mutta eivät riko 
            lihasta yhtä paljon. Kelkan työnnön erityispiirre on se että eksentristä vaihetta ei käytännössä ole. 
            Tätä voisi verrata mäkijuoksuun, mutta siten ettei sinun tarvitse koskaan laskea mäkeä alas.</p>
        
            
            <h2>Monipuolisuutta kelkkaharjoittelusta</h2>
             
            <p>Kelkan käyttö osana muuta treeniä tuo helposti treeniin vaihtelua ja monipuolisuutta. Kelkan kuormaa 
            säätämällä voidaan harjoittelun intensiteettiä muuttaa tarkoituksen mukaisesti. Kelkan työntö on 
            hyvä kokonaisvaltainen liike, joten kevyellä kuormalla tehtynä se soveltuu hyvin alkulämmittelyksi. 
            Kuormaa kasvattamalla tai vauhtia kiihdyttämällä hyytyy pian niin reidet kuin verenkiertoelimistönkin.
            Yksin kelkalla, tai yhdistelemällä muihin liikkeisiin, saadaan aikaan erinomainen syketreeni koko 
            kropalle.</p>
             
            <p>Kelkkaa voi myös soveltaa niin että treeni saadaan osumaan muihin lihaksiin. Kelkkaa voi vetää 
            taka- tai etuperin käyttämällä vetoremmejä, jolloin kropan vetävät lihakset työskentelevät. 
            Mielikuvitusta voi käyttää liikkeiden keksimisessä - voit vaikka vetää kelkkaa vaikka kylki edellä tai 
            pelkästään käsillä lattialla istuen, jolloin liike taas muuttuu täysin erilaiseksi.</p>
             
            <p>Usein kelkkaa käytetään osana muuta treeniä yhdistelemällä sitä muiden liikkeiden kanssa. Näin 
                treenin intensiteetti pysyy korkealla vaikka treeni olisi kestoltaan lyhyt.</p>
             
            <h2>Esimerkki kelkkatreenistä</h2>
             
            <p>Tässä esimerkki korkean intensiteetin treenistä kokeiltavaksi. Treeniä varten tarvitset kelkan, 
                sopivasti kuormaa kelkkaan (esimerkiksi muutama kiekko levypainoja) sekä leuanvetotangon. 
                Mikäli leuanveto ei vielä onnistu, voit käyttää kuminauhoja keventämiseen tai korvata leuanvedot 
                engassouduilla (5 leukaa = 10 rengassoutua)</p>
                
            <iframe width="640" height="360" src="https://www.youtube.com/embed/wG_KMMYvMnw" title="Pikatreeni; kelkantyöntö + leuanveto" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>


            <p>Tee seuraavia liikkeitä 4-6 kierrosta. Pyri tekemään liikkeet ilman taukoja.</p>
            
            <ul>
                <li>30 m Kelkan työntö</li>
                <li>5 x Leuanveto</li>
            </ul>
            
            <p>Ei muuta kun kelkkailemaan!</p>
            
            <p>-Mata</p>
                

        </article>




        <section class="container">
            <h2>Lue seuraavaksi</h2>
            <div class="row">
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='muscle_up_renkaissa' title='Muscle up renkaissa' titlePic='2018/muscleup_strip.jpg' blogDate='' firstPara='Muscle up, jota myös voimavedoksi sanotaan, on liike jossa urheilija punnertaa itsensä roikkumisasennosta renkaiden päälle rengaspitoon. Tässä artikkelissa käymme läpi muutamia vinkkejä liikkeen opettelemiseksi.'></BlogSummary>
                </article>
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='6-syyta-tehda-nopeusvoimaharjoittelua' title='6 syytä tehdä nopeusvoimaharjoittelua' titlePic='nopeusharjoittelu.jpg' blogDate='' firstPara='Lihasten tuottama voima voidaan lajitella käytännössä kolmeen luokkaan. Kaiken kivijalka on kestovoima, jonka päälle rakennetaan maksimi- ja nopeusvoima.'></BlogSummary>
                </article>
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='2022-09-11_otevoima' title='Otteen ja puristusvoiman vahvistaminen' titlePic='2022/FatGripzMave2.jpg' blogDate='' firstPara='Hyvästä puristusvoimasta on hyötyä niin kuntosalilla kuin kotitöissä. Lue tästä vinkit otevoiman kehittämiseen.'></BlogSummary>
                </article>
            </div>
        </section>



    </div>
{/if}

<style>


</style>